###
  Campaigns widget
###

class INTENT.widgets.UserlistFilter

  @ATTR_NAME: "data-widget-userlist-filter"

  constructor: (@el) ->
    @s = @.constructor
    @init_select2()

  init_select2: () =>
    @el.find('.select2-text').select2({
      tags: [],
      tokenSeparators: [",", ";"]
    })

    @el.find('.select2-text-single').select2({
      tags: [],
      maximumSelectionSize: 1
    })

    @el.find('.select2-select').select2({
      minimumResultsForSearch: -1
    })

    @el.find('select').select2({
      minimumResultsForSearch: -1
    })

    $(document).on "click", '.multiple-select2-arrow', ->
      open_select2 @parent()